/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from 'material-ui/styles';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  Legend
} from 'recharts';
import { CHART_COLORS } from '../../constants/globals';

const styles = () => ({
  container: {
    margin: 'auto'
  }
});

const yFormatter = tick => (
  tick > 1000 ? `${tick / 1000} GHz` : `${tick} MHz`
);

const COLOR_LENGTH = CHART_COLORS.length;

export const MaterialChart = ({
    classes,
    data,
    label,
    keys,
    mhzs
  }) => {
  return (
    <div>
      <h4>{label}</h4>
      <ResponsiveContainer width="90%" height={300} className={classes.container}>
        <LineChart
          data={data}
          margin={{
            top: 5, right: 30, left: 20, bottom: 5
          }}
        >
          <XAxis
            dataKey="mhz"
            type="number"
            domain={['datamin', 'datamax']}
            ticks={mhzs}
            tickFormatter={yFormatter}
          />
          <YAxis domain={['auto', 'auto']} />
          <CartesianGrid strokeDasharray="3 3" />
          <Tooltip labelFormatter={yFormatter} />
          <Legend />
          {keys.map((key, index) => (
            key === 'mhz' ? null : (
              <Line
                key={key}
                isAnimationActive={false}
                type="monotone"
                dataKey={key}
                stroke={CHART_COLORS[COLOR_LENGTH % index]}
                activeDot={{ r: 8 }}
              />
            )
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

MaterialChart.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.arrayOf(PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  )).isRequired,
  label: PropTypes.string,
  keys: PropTypes.arrayOf(PropTypes.string),
  mhzs: PropTypes.arrayOf(PropTypes.string),
};

MaterialChart.defaultProps = {
  label: "",
  keys: [],
  mhzs: []
};

export default withStyles(styles)(MaterialChart);


// WEBPACK FOOTER //
// ./src/components/common/MaterialChart.jsx